import React, { useState } from 'react'
import { Menu, Moon, Sun, X } from 'lucide-react'
import { Link } from 'react-scroll'
import { useTheme } from '../context/ThemeContext'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const { theme, toggleTheme } = useTheme()

  const navItems = [
    { label: 'Features', to: 'features' },
    { label: 'Why LaundryMate', to: 'why' },
    { label: 'Pricing', to: 'pricing' },
    { label: 'FAQ', to: 'faq' }
  ]

  return (
    <header className="sticky top-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center gap-0 group">
            <div className="w-16 h-16 flex items-center justify-center">
              <img src="/laundry-mate-logo.png" alt="LaundryMate" className="w-full h-full" />
            </div>
            <span className="hidden sm:block font-bold text-lg text-gray-900 dark:text-white">LaundryMate</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                smooth={true}
                duration={500}
                className="text-gray-700 dark:text-gray-300 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors cursor-pointer font-medium text-sm"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Right Actions */}
          <div className="flex items-center gap-3">
            <button
              onClick={toggleTheme}
              role="switch"
              aria-checked={theme === 'dark'}
              aria-label="Toggle theme"
              className={`relative w-14 h-8 rounded-full transition-all duration-300 flex items-center px-1 shadow-inner ${
                theme === 'dark' ? 'bg-cyan-600' : 'bg-gray-300'
              }`}
            >
              <div
                className={`absolute top-0.5 left-0.5 w-7 h-7 rounded-full flex items-center justify-center transform transition-all duration-300 ${
                  theme === 'dark'
                    ? 'translate-x-6 bg-gray-900 shadow-[0_0_8px_rgba(34,212,238,0.4)]'
                    : 'translate-x-0 bg-white shadow-md'
                }`}
              >
                {theme === 'dark' ? (
                  <Moon size={16} className="text-yellow-300" />
                ) : (
                  <Sun size={16} className="text-amber-400" />
                )}
              </div>
            </button>

            <a
              href="https://app.laundrymate.shop"
              className="hidden sm:inline-flex items-center px-5 py-2 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white rounded-lg font-semibold text-sm hover:shadow-lg transition-all duration-200 hover:scale-105"
            >
              Login
            </a>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="lg:hidden p-2 rounded-lg text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isOpen && (
          <nav className="lg:hidden pb-4 border-t border-gray-200 dark:border-gray-800">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                smooth={true}
                duration={500}
                onClick={() => setIsOpen(false)}
                className="block py-2 text-gray-700 dark:text-gray-300 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors cursor-pointer font-medium"
              >
                {item.label}
              </Link>
            ))}
            <a
              href="https://app.laundrymate.shop"
              className="block mt-4 w-full text-center px-5 py-2 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white rounded-lg font-semibold text-sm hover:shadow-lg transition-all"
            >
              Login
            </a>
          </nav>
        )}
      </div>
    </header>
  )
}
